<template>
  <div class="container" :class="isReady ? 'page-show' : 'page-hide'">
    <div class="pm-bid-flow clearfix">
      <div class="fl pm-bid-flow-title">项目<br>流程</div>
      <div class="fl pm-bid-flow-list">
          <ul class="clearfix">
              <li class="pm-bid-flow1">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第一步</span>
                      <p>阅读公告</p>
                  </div>
              </li>
                  <li class="pm-bid-flow2">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第二步</span>
                      <p>报名登记</p>
                  </div>
              </li>
                  <li class="pm-bid-flow3">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第三步</span>
                      <p>交保证金</p>
                  </div>
              </li>
                  <li class="pm-bid-flow4">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第四步</span>
                      <p>参与报价</p>
                  </div>
              </li>
                  <li class="pm-bid-flow5">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第五步</span>
                      <p>成交确认</p>
                  </div>
              </li>
                  <li class="pm-bid-flow6">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第六步</span>
                      <p>资金结算</p>
                  </div>
              </li>
                  <li class="pm-bid-flow7">
                  <i></i>
                  <div class="pm-bid-flow-bz">
                      <span>第七步</span>
                      <p>出具凭证</p>
                  </div>
              </li>
          </ul>
      </div>
    </div>
    <!-- 详情 -->
    <detail-info  :base-info="baseInfo"  :table-type="tableType" :section-id="sectionId" />
  </div>
</template>

<script>
import porpertyApi from "@/api/porperty"
import noticeApi from "@/api/newnotice"
import { formatterDateTime, parseTime } from "@/filters";
import { PROJECT_STATUS_BUTTON_TEXT } from "@/utils/constant"
export default {
  name: "ProjectInfo",
  components: {
    DetailInfo: () => import("./components/detailInfo.vue")
  },
  props: {},
  data() {
    return {
      isReady:false,
      id: "",
      sectionId: "",
      baseInfo: {},
      sectionList: [],
      tableType: "1"
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const params = this.$route.query
    this.id = params.id
    this.sectionId = params.sectionId || ""
    this.noticeType = params.noticeType || "1"
    this.tableType = params.tableType || "1"
    this.getNoticeDetail()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    formatterDateTime,
    // 获取公告详情
    getNoticeDetail() {
      this.loading = true
      noticeApi.detail(this.id).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          data.fbstartDate = parseTime(data.fbstartDate, "{y}-{m}-{d}")
          this.baseInfo = data
          this.$store.commit("permission/SET_DETAIL_TITLE", this.baseInfo.title)
        }
        this.isReady = true
      }).finally(() => {
        this.loading = false
      })
    }
  }
};
</script>

<style scoped lang="scss">
  .container{
    padding-bottom: 20px;
  }
  .page-show{
    opacity: 1;
  }
  .page-hide{
    opacity: 0;
    transition: all 0.5s;
  }
  .detail-header{
    border: 1px solid #ddd;
    background-color: #fff;
    .title{
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 94px;
      line-height: 36px;
      text-align: center;
      font-size: 26px;
      font-weight: bold;
    }
    .detail-info{
      border-top: 1px solid #ddd;
      padding: 30px 0;
      font-size: 16px;
      .detail-info-item{
        flex: 1;
        width: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .application-btn{
          width: 90px;
          height: 32px;
          border-radius: 0;
          padding: 0;
          margin-top: 14px;
          &.is-disabled{
            background-color: #ddd;
            border-color: #ddd;
          }
        }
      }
      .detail-info-item + .detail-info-item{
        border-left: 1px solid #ddd;
      }
    }
  }
  .notice-list{
    height: 100px;
    margin-top: 20px;
    border: 1px solid #ddd;
    padding: 0 37px;
    background-color: #fff;
    .notice-item{
      width: 250px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F5F5F5;
      font-size: 20px;
      color: #999;
      cursor: not-allowed;
      img{
        width: 25px;
        height: 25px;
        margin-right: 10px;
      }
    }
    .can-view{
      cursor: pointer;
      color: $--color-primary;
    }
    .active{
      cursor: pointer;
      background: $--color-primary;
      color: #fff;
    }
  }
  .detail-table{
    margin-top: 20px;
    border: 1px solid #ddd;
    border-bottom: 0;
    &::before{
      height: 0;
    }
    .select-btn{
        width: 70px;
        height: 24px;
        padding: 0;
        text-align: center;
        border-radius: 0;
      &.is-active{
        background-color: $--color-primary;
        color: #fff;
      }
    }
  }
  .detail-content{
    background-color: #fff;
    padding: 0 20px;
    border: 1px solid #ddd;
    margin-top: 20px;
    .detail-content-header{
      height: 136px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

.pm-bid-flow {border: 1px solid #e6e6e6;background: #fff;margin:0px 0px 0px;position: relative;padding:10px 0px;height: 100px;}
.pm-bid-flow .pm-bid-flow-title{padding:15px 20px;text-align: center;font-size:18px;border-right: 1px #ddd solid; font-weight: normal;color: #424242;line-height: 25px;}
.pm-bid-flow-list{ padding-top: 20px;position: relative;}
.pm-bid-flow-list li{float: left;position: relative;width: 133px;margin-left: 25px;padding-left: 49px;box-sizing: border-box;}
.pm-bid-flow-list li:first-child:before{background: none;}
.pm-bid-flow-list li:before{display: inline-block;width: 16px;height: 22px;background: url(@/assets/images/home/detail-pm-icon.png) no-repeat -232px -170px;top: 10px;left: -35px;position: absolute;content: "";}
.pm-bid-flow-list li i{display: inline-block;width: 40px;height: 40px;background: url(@/assets/images/home/detail-pm-icon.png) no-repeat;
  position: absolute;top: 0px;left: 0px;}
.pm-bid-flow-list li:hover{color: #e15717;cursor: pointer;}
.pm-bid-flow-list li:hover .pm-bid-flow-bz p{color: #e15717}
.pm-bid-flow-list li.pm-bid-flow1 i{background-position: 0px 0px;}
.pm-bid-flow-list li.pm-bid-flow2 i{background-position: 0px -57px;}
.pm-bid-flow-list li.pm-bid-flow3 i{background-position: 0px -115px;}
.pm-bid-flow-list li.pm-bid-flow4 i{background-position: 0px -172px;}
.pm-bid-flow-list li.pm-bid-flow5 i{background-position: 0px -230px;}
.pm-bid-flow-list li.pm-bid-flow6 i{background-position: 0px -344px;}
.pm-bid-flow-list li.pm-bid-flow7 i{background-position: 0px -288px;}

.pm-bid-flow-list li.pm-bid-flow1:hover i{background-position: -87px 0px;}
.pm-bid-flow-list li.pm-bid-flow2:hover i{background-position: -87px -57px;}
.pm-bid-flow-list li.pm-bid-flow3:hover i{background-position: -87px -115px;}
.pm-bid-flow-list li.pm-bid-flow4:hover i{background-position: -87px -172px;}
.pm-bid-flow-list li.pm-bid-flow5:hover i{background-position: -87px -230px;}
.pm-bid-flow-list li.pm-bid-flow6:hover i{background-position: -87px -344px;}
.pm-bid-flow-list li.pm-bid-flow7:hover i{background-position: -87px -288px;}
.pm-bid-flow-bz span{font-size: 12px;}
.pm-bid-flow-bz p{font-weight: bold;color: #333;}
</style>
